import React from 'react'
import { motion } from 'framer-motion';
import { Cursor, useTypewriter} from 'react-simple-typewriter'

import { AppWrap } from '../../wrapper';

import { images } from '../../constants';

import './Header.scss';

const scaleVariants = {
    whileInView: {
        scale: [0, 1],
        opacity: [0, 1],
        transition: {
            duration: 1,
            ease: 'easeInOut'
        }
    }
}

const Header = () => {

    const [caracs] = useTypewriter({
        words: ['developer.dart', 'WebDesigner.js', 'Freelancer'],
        loop: 0, // Infinit
        delaySpeed:2000
      })
    return (
        <div className='app__header app__flex'>
            <motion.div
                whileInView={{ x: [-100, 0], opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className='app__header-info'
            >
                <div className='app__header-badge'>
                    <h2 className="head-text">
                        <span>P</span>aulo 
                        <span>F</span>ernandes
                    </h2>
                    <div className='app__header-info'>
                        <h2 className="head-text">
                            <span>
                                {caracs}
                                <Cursor
                                    cursorColor='#b3ff00' 
                                    cursorStyle='_'
                                />
                            </span>
                        </h2>
                    </div>
                </div>
            </motion.div>
                    
            <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5, delayChildren: 0.5 }}
                className='app__header-img'
            >
                <img src={images.profile} alt='profile_bg' />
                <motion.img
                    whileInView={{ scale: [0, 1] }}
                    transition={{ duration: 1, ease: 'easeInOut' }}
                    className='overlay_circle'
                    src={images.circle}
                    alt='profile_circle'
                />
            </motion.div>
            <motion.div
                variant={scaleVariants}
                whileInView={scaleVariants.whileInView}
                className='app__header-circles'
            >
                {[images.react, images.flutter, images.css].map((circle, index) => (
                    <div className='circle-cmp app__flex' key={`circle-${index}`}>
                        <img src={circle} alt='circle' />
                    </div>
                ))}
            </motion.div>
        </div>
    )
}

export default AppWrap(Header, 'home');